import { z } from "zod";

import { fetchWithError, useParsedQueries, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { paginatedSchema } from "../pagination";

import { baseAssetWithTimeseriesSchema } from "./assetsBase";

export const measuringStationListItemSchema = baseAssetWithTimeseriesSchema.extend({
  name: z.string(),
  station_type: z.string(),
  region: z.string(),
  category: z.string(),
  frequency: z.string(),
});

export type MeasuringStationListItem = z.infer<typeof measuringStationListItemSchema>;

export const measuringStationListSchema = paginatedSchema(measuringStationListItemSchema);
export type MeasuringStationList = z.infer<typeof measuringStationListSchema>;

export const measuringStationSchema = measuringStationListItemSchema;
export type MeasuringStation = z.infer<typeof measuringStationSchema>;

export function useMeasuringStations(params = {}) {
  const url = combineUrlAndParams("/api/v4/measuringstations/", params);
  return useParsedQuery<MeasuringStationList>(
    ["lizard-api-v4", "measuringstations", url],
    () => fetchWithError(url),
    (json: unknown) => measuringStationListSchema.parse(json)
  );
}

export function useMeasuringStation(id: number) {
  return useParsedQuery<MeasuringStation>(
    ["lizard-api-v4", "measuringStations", id],
    () => fetchWithError(`/api/v4/measuringstations/${id}/`),
    (json: unknown) => measuringStationSchema.parse(json)
  );
}

export function useMultipleMeasuringStations(ids: number[]) {
  return useParsedQueries(
    ids.map((id) => {
      return {
        queryKey: ["lizard-api-v4", "measuringstations", id],
        fetchFunction: () => fetchWithError(`/api/v4/measuringstations/${id}/`),
        parseFunction: (json: unknown) => measuringStationSchema.parse(json),
      };
    })
  );
}
